import { defineFetch } from 'resift';

const makePostFiltersGetUsers = defineFetch({
  displayName: 'Post Filters Get Users',
  make: (key: string) => ({
    request: (filter: any, q?: string) => ({ http }) =>
      http({
        method: 'POST',
        route: '/search/users',
        data: { filter, q },
      }),
  }),
});

export default makePostFiltersGetUsers;
